// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ReleaseOut } from './releaseOut.zod.ts';
import { UserOut } from './userOut.zod.ts';

export const sessionOutIntegrationWritesEnabledDefault = true;

export const SessionOut = zod.object({
  "integration_writes_enabled": zod.boolean().default(sessionOutIntegrationWritesEnabledDefault),
  "mcp_enabled": zod.boolean(),
  "mcp_url": zod.union([zod.string(),zod.null()]),
  "navigation": zod.array(zod.string()),
  "permissions": zod.array(zod.string()),
  "release": ReleaseOut,
  "user": UserOut
});

export type SessionOut = zod.input<typeof SessionOut>;
export type SessionOutOutput = zod.output<typeof SessionOut>;
